// Dedicated UCAT marketing footer — shared by the landing page,
// feature writeups, and Insights. Does not touch the shared GlobalFooter.
import React from 'react';
import { useNavigate } from 'react-router-dom';
import CookieSettingsButton from '../../consent/CookieSettingsButton';
import './UcatLandingPage.css';

export default function UcatEditorialFooter() {
  const navigate = useNavigate();
  return (
    <footer className="ucat-editorial-footer">
      <div className="ucat-container">
        <div className="ucat-footer-grid">
          <div>
            <div className="ucat-footer-logo">IVORI<span className="ucat-footer-logo-suffix">Edu</span></div>
            <p className="ucat-footer-blurb">The AI for decision-makers. Tuned for the ones about to become one.</p>
            <p className="ucat-footer-contact-label">Questions? Email us:</p>
            <a href="mailto:support@ivoriai.com" className="ucat-footer-mail">support@ivoriai.com</a>
          </div>

          <div className="ucat-fcol">
            <h4>Company</h4>
            <a href="https://ivorilab.com" target="_blank" rel="noopener noreferrer">IVORI Lab</a>
            <button type="button" onClick={() => navigate('/method/ucat')}>IVORI Edu Method</button>
            <h4 style={{ marginTop: 36 }}>Products</h4>
            <a href="https://ivoriai.com" target="_blank" rel="noopener noreferrer">IVORI</a>
            <a href="https://ivoriai.com/" target="_blank" rel="noopener noreferrer">IVORI Edu</a>
          </div>

          <div className="ucat-fcol">
            <h4>Features</h4>
            <button type="button" onClick={() => navigate('/features/chat')}>Chat</button>
            <button type="button" onClick={() => navigate('/features/fluid')}>Fluid</button>
            <button type="button" onClick={() => navigate('/features/studio')}>Studio</button>
            <button type="button" onClick={() => navigate('/features/apps')}>Apps</button>
            <button type="button" onClick={() => navigate('/features/cases')}>Cases</button>
          </div>

          <div className="ucat-fcol">
            <h4>Exam Apps</h4>
            <a href="https://esat.edu.ivoriai.com/" target="_blank" rel="noopener noreferrer">ESAT</a>
            <a href="https://lnat.edu.ivoriai.com/" target="_blank" rel="noopener noreferrer">LNAT</a>
            <a href="https://tara.edu.ivoriai.com/" target="_blank" rel="noopener noreferrer">TARA</a>
            <a href="https://tmua.edu.ivoriai.com/" target="_blank" rel="noopener noreferrer">TMUA</a>
            <a href="https://ucat.edu.ivoriai.com/" target="_blank" rel="noopener noreferrer"><b>UCAT</b></a>
          </div>

          <div className="ucat-fcol ucat-fcol-wide">
            <h4>Interview Apps</h4>
            <a href="https://oxbridge.edu.ivoriai.com/" target="_blank" rel="noopener noreferrer">Oxbridge</a>
            <a href="https://medicalschool.edu.ivoriai.com/" target="_blank" rel="noopener noreferrer">Medical School</a>
            <a href="https://degreeapprenticeship.edu.ivoriai.com/" target="_blank" rel="noopener noreferrer" className="ucat-nowrap-link">Degree Apprenticeship</a>
            <h4 style={{ marginTop: 36 }}>Resources</h4>
            <button type="button" onClick={() => navigate('/insights')}>UCAT Insights</button>
          </div>
        </div>
      </div>

      <div className="ucat-footer-bottom-outer">
        <div className="ucat-container ucat-footer-bottom">
          <span>© {new Date().getFullYear()} IVORI Lab. all rights reserved.</span>
          <div className="ucat-footer-links">
            <button type="button" onClick={() => navigate('/privacy')}>Privacy</button>
            <button type="button" onClick={() => navigate('/terms-of-use')}>Terms</button>
            <button type="button" onClick={() => navigate('/safeguarding')}>Safeguarding</button>
            <button type="button" onClick={() => navigate('/cookies')}>Cookies</button>
            <CookieSettingsButton />
          </div>
        </div>
      </div>
    </footer>
  );
}
